export default {
    data() {
        return {
            lang: $('html').attr('lang'),
            isTablet: $('.branch-code-wrap').length > 0,
        };
    },
    mounted() { },
    created: function () { },
    watch: {},
    methods: {
        showAlert(title, content) {
            if (typeof content === 'object') {
                const contentObject = content
                content = ''
                Object.keys(contentObject).forEach(function (key) {
                    content += (content ? "<br>" : '') + contentObject[key][0];
                });
            }
            showAlert(title, content);
        },
        showSingleConfirmAlert(title, content, confirmMessage = '', closeFunction = '', confirmFunction = '', cancelFunction = '') {
            showSingleConfirmAlert(title, content, confirmMessage, closeFunction, confirmFunction, cancelFunction)
        },
        decimalPlace(val, decimalPlace) {
            return (Math.round(val * 100) / 100).toFixed(decimalPlace);
        },
        delayReload() {
            setTimeout(function () {
                location.reload();
            }, 3000);
        },
        closeConfirmAlert() {
            closeConfirmAlert();
        },
        //GTM
        pushToDataLayer(eventName, ecommerce) {
            if (!eventName || !ecommerce) {
                return false;
            }

            var object = {
                event: eventName,
                'ecommerce': ecommerce,
            };

            dataLayer.push(object);
        }
    },
    destroyed() { }
};
